import React from 'react';
import { connect } from 'react-redux';
import { RootDispatch } from '../../store';
import RejoinCallFloatingButton from './RejoinCallFloatingButton.view';

type RejoinCallFloatingDataProps = {
  joinCall: (_: unknown) => void;
};

export function RejoinCallFloatingData({ joinCall }: RejoinCallFloatingDataProps) {
  return <RejoinCallFloatingButton joinCall={joinCall} />;
}

const mapDispatch = ({ virtualWaitingRoom: { joinCall } }: RootDispatch) => ({
  joinCall,
});
// https://tigertext.atlassian.net/browse/TMG-837
// @ts-expect-error
export default connect(null, mapDispatch)(RejoinCallFloatingData);
